import { StyleSheet } from 'react-native';
import { darkestGrey, fontFamily } from '../../../constants/palette';

export default StyleSheet.create({
  button: {
    // marginLeft: 20,
  },
  container: {
    marginBottom: 10,
  },
  hover: {
    marginBottom: 10,
  },
  iconBox: {
    width: 48,
    height: 48,
    backgroundColor: darkestGrey,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },

  text: {
    fontFamily,
  },
  image: { width: 30, height: 25, marginLeft: 20 },
});
